import fecha from 'fecha'

/*
* 字符串日期处理
* @param {String}
* @return {Date} Date对象
*/

Date.formatString = function (string) {
  let str = string.replace(/[-|\/|\s|:]/g, ',')
  let dateArr = str.split(',')
  dateArr[1] = dateArr[1] - 1
  return new Date(...dateArr)
}

/*
* 日期格式化
* @param {[String, Date]}
* @return {String}
*/
Date.format = (date = new Date(), format = 'YYYY-MM-DD') => {
  let dateObj = date
  if (typeof(date) === 'string') {
    dateObj = Date.formatString(date)
  }
  return fecha.format(dateObj, format)
}


// WEBPACK FOOTER //
// ./src/prototype/Date.js